import { getInit } from "./InitGradeSelector";
import GradeSelector from "./components/toyota/GradeSelector";
import "../shared-components/css-modules/toyota/styles/globals.scss";

// Webpack entry point for Apheleia Grade Selector Toyota AEM
export const init = getInit(GradeSelector);
